import React, { useState } from 'react';
import { Box, Container, Typography, Card, CardContent, Grid } from '@mui/material';
import ReviewImage from '../../assets/effective.png';
import SkinAfter01 from '../../assets/serumafter.png';
import SkinBefore01 from '../../assets/serumbefore.png';
import SkinAfter02 from '../../assets/serum1after.png';
import SkinBefore02 from '../../assets/serum1before.png';
import SkinAfter03 from '../../assets/serum2after.png';
import SkinBefore03 from '../../assets/serum2before.png';
import SkinAfter04 from '../../assets/serum3after.png';
import SkinBefore04 from '../../assets/serum3before.png';
import useMediaQuery from '@mui/material/useMediaQuery';

export const Page7: React.FC = () => {
    const testimonials = [
        {
            image: SkinAfter01,
            hoverImage: SkinBefore01,
            title: 'Faded internal & external pigmentations, revealing a radiant complexion.',
            description: 'After 1.5 months of consistent use, significant improvements were noticed. The internal and external pigmentations have visibly faded, giving way to a more radiant and even-toned complexion. Additionally, the skin feels more hydrated and plump, with improved overall texture and glow.',
            skinType: 'Combination',
            duration: '1.5 months',
            productsUsed: 'ENERGY BOOST, HYDRA GLOW, HYALU MINERALS'
        },
        {
            image: SkinAfter02,
            hoverImage: SkinBefore02,
            title: 'Smoother texture, faded external pigmentations, revealing a radiant complexion.',
            description: 'After 1.5 months of consistent use, the skin texture became noticeably smoother. External pigmentations have visibly faded, revealing a more radiant and even-toned complexion with improved overall appearance.',
            skinType: 'Oily',
            duration: '1.5 months',
            productsUsed: 'ENERGY BOOST, HYDRA GLOW, HYALU MINERALS'
        },
        {
            image: SkinAfter03,
            hoverImage: SkinBefore03,
            title: 'Reduce acne, Acne pit repair, improves in skin texture.',
            description: 'After 1.5 months of consistent use, significant improvements were observed. Acne has been reduced, acne pits are being repaired, and the overall skin texture has noticeably improved with a smoother and more refined appearance.',
            skinType: 'Sensitive',
            duration: '1.5 months',
            productsUsed: 'PRO AGE EXPERT, HYDRA GLOW'
        },
        {
            image: SkinAfter04,
            hoverImage: SkinBefore04,
            title: 'Acne pit repair, improves in skin texture, redness improved.',
            description: 'After 1.5 months of consistent use, significant improvements were observed. Acne pits are being repaired, skin texture has noticeably improved, and redness has been reduced, resulting in a calmer and more even complexion.',
            skinType: 'Dry',
            duration: '1.5 months',
            productsUsed: 'PRO AGE EXPERT, HYDRA GLOW, HYALU MINERALS'
        },
    ];

    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
    const isMobile = useMediaQuery('(max-width:600px)');

    return (
        <Container maxWidth={false} sx={{ paddingTop: '50px', paddingBottom: '50px', backgroundColor: '#fff' }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: {
                        sx: 1,
                        sm: 2,
                        lg: 5
                    },
                }}
            >
                <Grid container spacing={4} alignItems="stretch">
                    {/* Left Section - Image with Title Overlay */}
                    <Grid item xs={12} md={5}>
                        <Box
                            sx={{
                                borderRadius: '36px',
                                overflow: 'hidden',
                                height: '100%',
                                position: 'relative',
                                minHeight: {
                                    xs: '400px',
                                    md: '600px'
                                }
                            }}
                        >
                            <Box
                                component="img"
                                src={ReviewImage}
                                alt="What They Say"
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '36px',
                                }}
                            />
                            <Typography
                                sx={{
                                    position: 'absolute',
                                    top: {
                                        xs: '8%',
                                        md: '10%'
                                    },
                                    left: {
                                        xs: '8%',
                                        md: '8%'
                                    },
                                    fontFamily: 'ClaireMurphy',
                                    fontSize: {
                                        xs: '30px',
                                        sm: '40px',
                                        md: '50px',
                                    },
                                    fontWeight: 400,
                                    lineHeight: '1.2',
                                    color: '#fff',
                                    zIndex: 1,
                                    textShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                                }}
                            >
                                WHAT THEY SAY
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Right Section - Before/After Testimonials */}
                    <Grid item xs={12} md={7}>
                        <Grid container spacing={3}>
                            {testimonials.map((testimonial, index) => (
                                <Grid item xs={12} sm={6} key={index} display="flex">
                                    <Card
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '100%',
                                            borderRadius: '20px',
                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                            padding: '20px',
                                            height: '100%',
                                        }}
                                    >
                                        {/* Before/After Image */}
                                        <Box
                                            sx={{
                                                width: '100%',
                                                borderRadius: '20px',
                                                overflow: 'hidden',
                                                position: 'relative',
                                                height: '200px',
                                                marginBottom: '16px',
                                                display: isMobile ? 'flex' : 'block',
                                                gap: isMobile ? '8px' : 0,
                                            }}
                                            onMouseEnter={() => !isMobile && setHoveredIndex(index)}
                                            onMouseLeave={() => !isMobile && setHoveredIndex(null)}
                                        >
                                            <Box
                                                component="img"
                                                src={testimonial.hoverImage}
                                                alt="Before"
                                                sx={{
                                                    width: isMobile ? '48%' : '100%',
                                                    height: '100%',
                                                    borderRadius: '20px',
                                                    objectFit: 'cover',
                                                    position: isMobile ? 'relative' : 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    opacity: isMobile ? 1 : (hoveredIndex === index ? 0 : 1),
                                                    transition: 'opacity 0.3s ease-in-out',
                                                    zIndex: 1,
                                                }}
                                            />
                                            <Box
                                                component="img"
                                                src={testimonial.image}
                                                alt="After"
                                                sx={{
                                                    width: isMobile ? '48%' : '100%',
                                                    height: '100%',
                                                    borderRadius: '20px',
                                                    objectFit: 'cover',
                                                    position: isMobile ? 'relative' : 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    opacity: isMobile ? 1 : (hoveredIndex === index ? 1 : 0),
                                                    transition: 'opacity 0.3s ease-in-out',
                                                    zIndex: 2,
                                                }}
                                            />
                                            {isMobile && (
                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        bottom: '10px',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        display: 'flex',
                                                        gap: '8px',
                                                        zIndex: 3,
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            textAlign: 'center',
                                                            color: 'rgba(0, 48, 135, 1)',
                                                            fontWeight: '600',
                                                            fontFamily: 'Quicksand',
                                                            fontSize: '10px',
                                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                            padding: '4px 8px',
                                                            borderRadius: '8px',
                                                        }}
                                                    >
                                                        BEFORE
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            textAlign: 'center',
                                                            color: 'rgba(0, 48, 135, 1)',
                                                            fontWeight: '600',
                                                            fontFamily: 'Quicksand',
                                                            fontSize: '10px',
                                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                            padding: '4px 8px',
                                                            borderRadius: '8px',
                                                        }}
                                                    >
                                                        AFTER
                                                    </Typography>
                                                </Box>
                                            )}
                                            {!isMobile && (
                                                <Typography
                                                    sx={{
                                                        position: 'absolute',
                                                        bottom: '10px',
                                                        left: '50%',
                                                        transform: 'translateX(-50%)',
                                                        textAlign: 'center',
                                                        color: 'rgba(0, 48, 135, 1)',
                                                        fontWeight: '600',
                                                        fontFamily: 'Quicksand',
                                                        fontSize: '12px',
                                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                                        padding: '4px 12px',
                                                        borderRadius: '12px',
                                                        zIndex: 3,
                                                    }}
                                                >
                                                    {hoveredIndex === index ? 'AFTER' : 'BEFORE'}
                                                </Typography>
                                            )}
                                        </Box>

                                        <CardContent sx={{ flexGrow: 1, padding: '0 !important' }}>
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Quicksand, sans-serif',
                                                    fontSize: '18px',
                                                    fontWeight: 600,
                                                    lineHeight: '24px',
                                                    letterSpacing: '-0.02em',
                                                    textAlign: 'left',
                                                    color: 'rgba(61, 61, 61, 1)',
                                                    marginBottom: '10px',
                                                }}
                                            >
                                                {testimonial.title}
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Quicksand, sans-serif',
                                                    fontSize: '14px',
                                                    fontWeight: 400,
                                                    lineHeight: '20px',
                                                    textAlign: 'left',
                                                    color: 'rgba(136, 136, 136, 1)',
                                                    marginBottom: '16px',
                                                }}
                                            >
                                                {testimonial.description}
                                            </Typography>
                                        </CardContent>

                                        {/* Details Grid */}
                                        <Grid container spacing={1.5}>
                                            <Grid item xs={6}>
                                                <Box
                                                    sx={{
                                                        padding: '8px 12px',
                                                        border: '1px solid rgba(221, 221, 221, 1)',
                                                        borderRadius: '16px',
                                                        height: '100%',
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: '700',
                                                            fontFamily: 'Quicksand',
                                                            fontSize: '11px',
                                                            color: 'rgba(0, 48, 135, 1)',
                                                            marginBottom: '4px',
                                                        }}
                                                    >
                                                        SKIN TYPE
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontFamily: 'Quicksand',
                                                            fontSize: '12px',
                                                            color: 'rgba(61, 61, 61, 1)',
                                                        }}
                                                    >
                                                        {testimonial.skinType}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Box
                                                    sx={{
                                                        padding: '8px 12px',
                                                        border: '1px solid rgba(221, 221, 221, 1)',
                                                        borderRadius: '16px',
                                                        height: '100%',
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: '700',
                                                            fontFamily: 'Quicksand',
                                                            fontSize: '11px',
                                                            color: 'rgba(0, 48, 135, 1)',
                                                            marginBottom: '4px',
                                                        }}
                                                    >
                                                        DURATION
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontFamily: 'Quicksand',
                                                            fontSize: '12px',
                                                            color: 'rgba(61, 61, 61, 1)',
                                                        }}
                                                    >
                                                        {testimonial.duration}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Box
                                                    sx={{
                                                        padding: '8px 12px',
                                                        border: '1px solid rgba(221, 221, 221, 1)',
                                                        borderRadius: '16px',
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontWeight: '700',
                                                            fontFamily: 'Quicksand',
                                                            fontSize: '11px',
                                                            color: 'rgba(0, 48, 135, 1)',
                                                            marginBottom: '4px',
                                                        }}
                                                    >
                                                        PRODUCTS USED
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontFamily: 'Quicksand',
                                                            fontSize: '12px',
                                                            color: 'rgba(61, 61, 61, 1)',
                                                        }}
                                                    >
                                                        {testimonial.productsUsed}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};
